class MaxCharsDirective {
    constructor($timeout, $rootScope) {
        this.restrict = 'A';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$scope = null;
        this.maxChars = null;
    }

    link($scope, elem, attrs) {
        this.$scope = $scope;
        $scope.elem = elem;
        $scope.attrs = attrs;
        attrs.$set('ngTrim', 'false');
        this.maxChars = parseInt(attrs.maxChars, 10);
        this.updateCounter();
        const onInputChange = (e) => {
            if (e.originalEvent.clipboardData && elem[0].value.length + e.originalEvent.clipboardData.getData('text').length > this.maxChars) {
                const charsLeft = this.maxChars - elem[0].value.length + 1;
                if (charsLeft <= 0) {
                    e.preventDefault();
                    return false;
                }

                elem[0].value = elem[0].value + e.originalEvent.clipboardData.getData('text').substring(0, charsLeft - 1);
                e.preventDefault();
                elem.triggerHandler('input');
                return false;
            }
            if (elem[0].value.length >= this.maxChars) {
                e.preventDefault();
                return false;
            }
            this.$timeout(() => {
                this.updateCounter();
            }, 200);
        }
        elem.bind('keypress', onInputChange);
        elem.bind('paste', onInputChange);
        elem.bind('keyup', () => {
            this.updateCounter();
        });
    }

    updateCounter() {
        if (this.$scope.attrs.maxCharsCounter) {
            angular.element('#' + this.$scope.attrs.maxCharsCounter)[0].innerHTML = this.$scope.elem[0].value.length + ' / ' + this.maxChars;
        }
    }

    static directiveFactory($timeout, $rootScope) {
        'ngInject';
        return new MaxCharsDirective($timeout, $rootScope);
    }
}

export default MaxCharsDirective;
